import { render, staticRenderFns } from "./UserLoginView.vue?vue&type=template&id=0f073621&scoped=true&"
import script from "./UserLoginView.vue?vue&type=script&lang=js&"
export * from "./UserLoginView.vue?vue&type=script&lang=js&"
import style0 from "./UserLoginView.vue?vue&type=style&index=0&id=0f073621&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f073621",
  null
  
)

export default component.exports